// Auto generated file, do not manually modify!
// com.hotpads.satellite.screeningcriteria.enums.SatelliteRenterProfileScreeningCriteriaFilterType

export enum SatelliteRenterProfileScreeningCriteriaFilterType {
  MIN_CREDIT_SCORE = 'MIN_CREDIT_SCORE',
  MIN_MONTHLY_INCOME = 'MIN_MONTHLY_INCOME',
  PET_POLICY = 'PET_POLICY',
}

export const SatelliteRenterProfileScreeningCriteriaFilterType_values = [
  SatelliteRenterProfileScreeningCriteriaFilterType.MIN_CREDIT_SCORE,
  SatelliteRenterProfileScreeningCriteriaFilterType.MIN_MONTHLY_INCOME,
  SatelliteRenterProfileScreeningCriteriaFilterType.PET_POLICY,
] as const;
